import { blockCodeEditor } from './blockCodeEditor';
import { editEditorCommand } from './editCommand';
import { openLinkInNewTab } from './openLinkInNewTab';
import webpreset from './webpreset';
import editorAssetManager from './editorAssetManager';
import styleManager from './styleManager';
import { crossTabCopyPaste } from './crossTabCopyPaste';
import { deviceChangeSelectCommand } from './deviceChangeCommand';
import searchStylesCommand from './searchStylesCommand';
import { blocksOnClick } from './blocksOnClick';

export default (editor) => {
    editEditorCommand(editor);
    openLinkInNewTab(editor);
    blockCodeEditor(editor);
    webpreset(editor);
    editorAssetManager(editor);
    styleManager(editor);
    crossTabCopyPaste(editor);
    deviceChangeSelectCommand(editor);
    searchStylesCommand(editor);
    blocksOnClick(editor);
    // paddingCommand(editor);
};
